import { TOGGLE_NOTIFICATION, TOGGLE_SPINNER } from "utils/constants";

export const toggleNotification = (msg) => (dispatch, getState) => {
  const notificationMsg = getState().app.notificationMsg ? null : msg
  return dispatch({
    type: TOGGLE_NOTIFICATION,
    data: { notificationMsg }
  });
}

export const toggleSpinner = () => (dispatch, getState) => {
  return dispatch({
    type: TOGGLE_SPINNER,
    data: { showSpinner: !getState().app.showSpinner }
  });
}


// WEBPACK FOOTER //
// ./src/actions/commonActions.js